<template>
    <div class="enSet" id="enSet">
        <div class="app-init-container">
            <div class="team">
                <div class="wrapper-app">
                    <div class="header flex align-cen">
                        <div class="header-title-wrap clearfix">
                            账号设置
                        </div>
                        <div class="account flex align-cen mft">
                             <div class="inputPreview">{{user.username || '暂无'}}</div>
                            <div class="tc" @click="loginout">退出</div>
                        </div>
                    </div>
                    <div class="cen-content">
                        <div class="form-horizontal">
                            <div class="control-group flex align-cen">
                                <div class="control-label">登录账号：</div>
                                <div class="controls controls-account flex align-cen">
                                    <div class="show-text">{{user.username}}</div>
                                    <div class="js-change-pw" @click="openPh">修改账号</div>
                                    <div class="js-change-pw" @click="openPs">修改密码</div>
                                </div>
                            </div>
                              <div class="control-group flex align-cen">
                                <div class="control-label">昵称：</div>
                                <div class="controls  flex align-cen">
                                    <div class="show-text show-name" @click="nameDiloag">{{user.name}}</div>
                                    <!-- <div class="js-change-pw" @click="openPh">修改密码</div> -->
                                </div>
                            </div>
                             <div class="control-group flex align-cen">
                                <div class="control-label">头像：</div>
                                <div class="controls controls-account flex align-cen">
                                    <div class="show-img">
                                        <img :src="user.avatar" alt="">
                                    </div>
                                    <div class="js-change-pw" @click="imgDiloag">修改</div>
                                </div>
                            </div>
                              <div class="control-group flex align-cen">
                                <div class="control-label"></div>
                                <div class="controls controls-account flex align-cen">
                                    <div class="show-btn" @click="$router.push('/webenterprise/homePage')">
                                        返回首页
                                    </div>
                                    <!-- <div class="js-change-pw" @click="$router.push('/webenterprise/homePage')">返回首页</div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="breadcrumb-container">
            <div class="next-breadcrumb flex align-cen">
                <div class="next-breadcrumb-item">
                    <span>账号设置</span>
                </div>
                    <div class="next-breadcrumb-separator">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="next-breadcrumb-item">
                        <span class="next-breadcrumb-text activated">
                                基本信息
                        </span>
                    </div>
            </div>
        </div>
        <div class="enSet-head flex align-cen">
            <div class="avatar-block">
                <div class="avatar">
                    <span class="next-avatar">
                        <img :src="user.avatar" alt="">
                    </span>
                    <div class="sc-chPdSV" @click="imgDiloag">
                        修改
                    </div>
                </div>
            </div>
            <div class="next-form-preview flex align-cen">
                <div class="next-row flex align-cen">
                    <div class="label">姓名：</div>
                    <div class="inputPreview">{{user.name}}
                        <span @click="nameDiloag">修改</span>

                    </div>
                </div>
                 <div class="next-row flex align-cen">
                    <div class="label">账号ID：</div>
                    <div class="inputPreview">{{user.id}}</div>
                </div>
                <div class="next-row flex align-cen">
                    <div class="label">登录帐号：</div>
                    <div class="inputPreview">{{user.username || '暂无'}}
                         <span  @click="openPh">修改</span>

                    </div>
                </div>
                <div class="next-row flex align-cen">
                    <div class="label">密码：</div>
                    <div class="inputPreview">******
                         <span @click="openPs">修改</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="Setbtn" @click="loginout()">
            退出登录
        </div> -->
         <el-dialog
  :visible.sync="centerDialogVisible"
  width="25%"
  :append-to-body="true"
  center
  top="30vh"
  title="修改头像"
  v-if="centerDialogVisible"
  >
    <div class="formUp" >
            <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    :on-error="handleAvatarerr"
                    >
                    <div slot="tip" class="el-upload__tip">支持格式：<span style="color:#f56c6c">png、jpg、jpeg</span></div>
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">120*120</span></div>
                    <img :src="pic" class="avatar" v-if="pic">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="pic" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(1)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(1)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="pic" alt="">
                    </el-dialog>
                    </el-upload>
        <div class="subBtn flex align-cen">
            <div class="cancl" @click="centerDialogVisible = false">取消</div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load subTd"
             @click="edit"
            >
          确定
           </el-button>
        </div>
    </div>
</el-dialog>
 <el-dialog
  :visible.sync="centerDialogVisible1"
  width="30%"
  :append-to-body="true"
  center
  top="30vh"
  title="修改密码"
  v-if="centerDialogVisible1"
  >
    <div class="form-edit" v-if="!psNext">
          <el-input placeholder="请输入登录账号" v-model="phone">
                <template slot="prepend">+86</template>
            </el-input>
              <el-input placeholder="请输入验证码" v-model="code">
                <template slot="append">
                    <div class="sendCode"
                   @click="isSend ? sendcode() : ''"
                    >{{sendmsg}}</div>
                </template>
            </el-input>
               <div class="subBtn flex align-cen">
            <div class="cancl" @click="centerDialogVisible1 = false">取消</div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load subTd"
             @click="editPsNext"
            >
          下一步
           </el-button>
        </div>
    </div>
    <div class="form-edit"  v-if="psNext">
         <el-input placeholder="请输入新密码" v-model="password">
        </el-input>
        <el-input placeholder="请确认新密码" v-model="confirmPassword">
        </el-input>
             <div class="subBtn flex align-cen">
            <div class="cancl" @click="centerDialogVisible1 = false">取消</div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load subTd"
             @click="editPs"
            >
            完成
           </el-button>
        </div>
    </div>
 </el-dialog>
  <el-dialog
  :visible.sync="centerDialogVisible2"
  width="30%"
  :append-to-body="true"
  center
  top="30vh"
  title="修改登录账号"
  v-if="centerDialogVisible2"
  >
    <div class="form-edit" v-if="!psNext1">
          <el-input placeholder="请输入登录账号" v-model="phone1">
                <template slot="prepend">+86</template>
            </el-input>
              <el-input placeholder="请输入验证码" v-model="code1">
                <template slot="append">
                    <div class="sendCode"
                   @click="isSend1 ? sendcode1() : ''"
                    >{{sendmsg1}}</div>
                </template>
            </el-input>
               <div class="subBtn flex align-cen">
            <div class="cancl" @click="centerDialogVisible2 = false">取消</div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load subTd"
             @click="editPhNext"
            >
          下一步
           </el-button>
        </div>
    </div>
    <div class="form-edit"  v-if="psNext1">
              <el-input placeholder="请输入新手机号码" v-model="phone2">
                <template slot="prepend">+86</template>
            </el-input>
              <el-input placeholder="请输入验证码" v-model="code2">
                <template slot="append">
                    <div class="sendCode"
                   @click="isSend2 ? sendcode2() : ''"
                    >{{sendmsg2}}</div>
                </template>
            </el-input>
               <div class="subBtn flex align-cen">
            <div class="cancl" @click="centerDialogVisible2 = false">取消</div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load subTd"
             @click="editPh"
            >
                 确定
           </el-button>
        </div>
    </div>
 </el-dialog>
    </div>
</template>
<script>
import LocaStorage from "../../utils/localstorage.js"
import { editInfo,updatePwd,verifyCode,updatePwdSub,updatePhone,verifyCode1,updateNewPhone,updateLoginName} from "@/api/enterprise/index" // 修改头像、修改密码发送验证码、下一步、密码确认、修改手机号发送验证码、修改手机下一步、修改新手机号验证码、修改手机号
export default {
    name:'enSetting',
    data () {
        return {
            password:'',
            confirmPassword:'',
            sendmsg:'获取验证码',
            phone:'',
            code:'',
            phone1:'',
            code1:'',
            phone2:'',
            code2:'',
            oploadDialogVisible:false,
            headers:{},
            centerDialogVisible:false,
            centerDialogVisible1:false,
            centerDialogVisible2:false,
            loading:false,
            user:{},
            tabPosition:'left',
            pic:'',
            uploadBoolean:false,
            isSend:true,
            isSend1:true,
            isSend2:true,
            psNext:false,
            psNext1:false,
            sendmsg1:'获取验证码',
            sendmsg2:'获取验证码',
            timeFun:'',
            timeFun1:''
        }
    },
    created () {
         document.title = "账号设置"
        this.user =  LocaStorage.setAge().get('userinfo1')
         let token = LocaStorage.setAge().get('token1')
          if(token){
            this.headers = {
                'Authorization': token
            }
        }else{
           this.loginout() 
        }
    },
    methods: {
          // 修改手机
        editPh(){
            if(!this.phone2) return this.$util.Notifi('请输入新账号','error','fa-exclamation-circle');
            if(!this.code2) return this.$util.Notifi('请确认验证码','error','fa-exclamation-circle');
             let params = {
                loginName:this.phone2,
                verifyCode:this.code2
            }
               updateLoginName(params,'enterprise')
            .then(res =>{
                if(res.code == 0){
                    this.$util.Notifi('账号修改成功','success','fa-check');
                    this.psNext1 = false
                    this.centerDialogVisible2 = false
                    setTimeout(() => {
                        this.loginout()
                    }, 100);
                    }else{
                        this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
            })
            .catch(res =>{
                 this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
            })
        },
        // 修改密码
        editPs(){
            if(!this.password) return this.$util.Notifi('请输入新密码','error','fa-exclamation-circle');
            if(!this.confirmPassword) return this.$util.Notifi('请确认新密码','error','fa-exclamation-circle');
             let params = {
                password:this.password,
                confirmPassword:this.confirmPassword
            }
               updatePwdSub(params,'enterprise')
            .then(res =>{
                if(res.code == 0){
                    this.$util.Notifi(res.data,'success','fa-check');
                    this.psNext = false
                    this.centerDialogVisible1 = false
                    setTimeout(() => {
                        this.loginout()
                    }, 100);
                    }else{
                        this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
            })
            .catch(res =>{
                 this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
            })
        },
        
        // 修改密码下一步
        editPsNext(){
            if(!this.code) return this.$util.Notifi('请先输入验证码','error','fa-exclamation-circle');
              let params = {
                loginName:this.phone,
                verifyCode:this.code
            }
               verifyCode(params,'enterprise')
            .then(res =>{
                if(res.code == 0){
                    this.psNext = true
                    }else{
                         this.psNext = false
                        this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
            })
            .catch(res =>{
                 this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
            })
        },
          // 修改手机下一步
        editPhNext(){
            if(!this.code1) return this.$util.Notifi('请先输入验证码','error','fa-exclamation-circle');
              let params = {
                loginName:this.phone1,
                verifyCode:this.code1
            }
               verifyCode1(params,'enterprise')
            .then(res =>{
                if(res.code == 0){
                    this.psNext1 = true
                    }else{
                        this.psNext1 = false
                        this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
            })
            .catch(res =>{
                 this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
            })
        },
            // 修改手机发送验证码
        sendcode1(){
            if(!this.phone1) return this.$util.Notifi('请先输入账号','error','fa-exclamation-circle');
            let tel = /^1[345789]\d{9}$/
            if (!tel.test(this.phone1)) return this.$util.Notifi('请输入正确手机号','error','fa-exclamation-circle');
                 updatePhone({
                id:this.phone1
              },'enterprise')
            .then(res => {
            if(res.code == 0){
            let timer = 60;
          this.sendmsg1 = timer + "秒";
           this.timeFun = setInterval(() => {
            --timer;
            this.sendmsg1 = timer + "秒";
            if(timer < 10) this.sendmsg1 = '0' + timer + "秒";
            if (timer == 0) {
                this.isSend1 = true;
                this.sendmsg1 = "重新发送";
                clearInterval(this.timeFun);
                }
             }, 1000);
            }else{
                this.$message.error(res.msg)
                this.isSend1 = true;
            }
            })
            .catch(err => {
                this.isSend1 = true;
            })
        },
              // 修改新手机号发送验证码
        sendcode2(){
            if(!this.phone2) return this.$util.Notifi('请输入新账号','error','fa-exclamation-circle');
            let tel = /^1[345789]\d{9}$/
            if (!tel.test(this.phone2)) return this.$util.Notifi('请输入正确手机号','error','fa-exclamation-circle');
             this.isSend2 = false;
                 updateNewPhone({
                id:this.phone2
              },'enterprise')
            .then(res => {
            if(res.code == 0){
            let timer = 60;
          this.sendmsg2 = timer + "秒";
           this.timeFun1 = setInterval(() => {
            --timer;
            this.sendmsg2 = timer + "秒";
            if(timer < 10) this.sendmsg2 = '0' + timer + "秒";
            if (timer == 0) {
                this.isSend2 = true;
                this.sendmsg2 = "重新发送";
                clearInterval(this.timeFun1);
                }
             }, 1000);
            }else{
                this.$message.error(res.msg)
                this.isSend2 = true;
            }
            })
            .catch(err => {
                this.isSend2 = true;
            })
        },
        // 修改密码发送验证码
        sendcode(){
            if(!this.phone) return this.$util.Notifi('请先输入账号','error','fa-exclamation-circle');
            let tel = /^1[345789]\d{9}$/
            if (!tel.test(this.phone)) return this.$util.Notifi('请输入正确手机号','error','fa-exclamation-circle');
             this.isSend = false;
                 updatePwd({
                id:this.phone
              },'enterprise')
            .then(res => {
            if(res.code == 0){
            let timer = 60;
          this.sendmsg = timer + "秒";
           this.timeFun = setInterval(() => {
            --timer;
            this.sendmsg = timer + "秒";
            if(timer < 10) this.sendmsg = '0' + timer + "秒";
            if (timer == 0) {
                this.isSend = true;
                this.sendmsg = "重新发送";
                clearInterval(this.timeFun);
                }
             }, 1000);
            }else{
                this.$message.error(res.msg)
                this.isSend = true;
            }
            })
            .catch(err => {
                this.isSend = true;
            })
        },
         openPh(){
            this.psNext1 = false
            this.code1 =""
            this.phone2 = ""
            this.code2 = ""
            this.centerDialogVisible2 = true
            this.phone1 = this.user.username
             clearInterval(this.timeFun);
             clearInterval(this.timeFun1);
             this.sendmsg1 = "获取验证码"
             this.isSend1 = true
             this.sendmsg2 = "获取验证码"
             this.isSend2 = true
        },
        openPs(){
            this.psNext = false
            this.password=""
            this.confirmPassword=""
            this.code =""
            this.centerDialogVisible1 = true
            this.phone = this.user.username
             clearInterval(this.timeFun);
             this.sendmsg = "获取验证码"
             this.isSend = true
        },
        edit(){
             this.loading = true
            let params = {
                avatar:this.pic
            }
            editInfo(params,'enterprise')
            .then(res =>{
               this.loading = false
                if(res.code == 0){
                       this.$util.Notifi('修改成功','success','fa-check');
                       this.centerDialogVisible = false
                       this.user = res.data.user_info
                       LocaStorage.setAge().set('userinfo1',res.data.user_info)
                    }else{
                        this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
            })
            .catch(res =>{
                this.loading = false
                 this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
            })
        },
        // 修改姓名
        nameDiloag(){
         this.$prompt('请输入昵称', '修改昵称', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder:this.user.name
        }).then(({ value }) => {
           let params = {
                userName:value
            }
               editInfo(params,'enterprise')
            .then(res =>{
                if(res.code == 0){
                       this.$util.Notifi('修改成功','success','fa-check');
                       this.user = res.data.user_info
                       LocaStorage.setAge().set('userinfo1',res.data.user_info)
                    }else{
                        this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
            })
            .catch(res =>{
                 this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
            })
        }).catch(() => {});
        },
        // 打开修改头像
        imgDiloag(){
            this.pic = ''
            this.centerDialogVisible = true
            this.uploadBoolean = false
        },
         // 图片放大
         oploadImgPre(type){
             this.oploadDialogVisible = true
            },
        oploadImgDel(){
               this.pic = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
            },
     handleAvatarSuccess(res, file) {
        this.pic = res.data.url
        if(this.pic){
        this.uploadBoolean = true
         }
      },
      handleAvatarerr(err,file){
        this.uploadBoolean = false
      },
        // 退出登录
        loginout(){
            localStorage.removeItem('token1')
            localStorage.removeItem('userinfo1')
               let params = {
                redirectUrl:'homePage',
            }
                this.$router.push({
            name:'enLogin',
            query: params
         })
        },
    },
}
</script>
<style lang="scss" scoped>
    .enSet{
        .app-init-container{
                zoom: 1;
                margin: 0 auto;
                padding: 0;
                width: 1000px;
            .team{
                .wrapper-app{
                    width: 800px;
                    margin: 0 auto;
                    .header{
                     margin-top: 40px;
                    color: #666;
                    .header-title-wrap{
                        position: relative;
                        top: 7px;
                        font-size: 16px;
                        color: #333;
                        padding-left: 10px;
                        // margin: 0 300px 0 80px;
                    }
                    .account{
                        .inputPreview{
                            font-size: 12px;
                        }
                        .tc{
                            cursor: pointer;
                            color: #07d;
                            margin-left: 10px;
                        }
                        
                    }
                    }
                    .cen-content{
                        margin-top: 20px;
                        word-break: break-all;
                        background-color: #fff;
                        border: 1px solid #e5e5e5;
                        padding: 0 20px 20px;
                        font-size: 14px;
                        min-height: 400px;
                        .form-horizontal{
                        margin-top: 30px;
                        position: relative;
                        padding-left: 50px;
                        .control-group{
                             margin-bottom: 20px;
                            .control-label{
                            font-size: 12px;
                            color: #333;                           
                            line-height: 18px;
                             width: 120px;
                            text-align: right;
                            }
                            .controls{
                                margin-left: 50px;
                                font-size: 14px;
                               .show-name{
                                    border-radius: 2px;
                                padding: 8px 10px;
                                font-size: 12px;
                                border: 1px solid #ccc;
                                width: 220px;
                               }
                               .show-img{
                                width: 60px;
                                height: 60px;
                               }
                               .show-btn{
                                    color: #fff;
                                    background-color: #07d;
                                    border-color: #006cc9;
                                    width: 140px;
                                    height: 38px;
                                    line-height: 38px;
                                    text-align: center;
                                    border-radius: 3px;
                                    cursor: pointer;
                               }
                                .js-change-pw{
                                        font-size: 12px;
                                        color: #07d;
                                        margin-left: 30px;
                                        cursor: pointer;
                                }
                            }
                        }
                        }
                    }
                }
            }
        }
        // background-color: rgb(250, 250, 250);
        // padding: 20px;
       
        .breadcrumb-container{
            margin-bottom: 14px;
              .next-breadcrumb {
                margin: 0;
                padding: 0;
                white-space: nowrap;
                height: 16px;
                line-height: 16px;
                .next-breadcrumb-item{
                    span{
                        color: #999;
                        height: 16px;
                        min-width: 16px;
                        font-size: 12px;
                        line-height: 16px;
                    }
                    .activated{
                        color: #181818;
                    }
                }
                        .next-breadcrumb-separator{
                        color: #181818;
                        vertical-align: top;
                        i{
                            transform: scale(.5);
                            margin-left: 10px;
                            margin-right: 10px;
                        }
                    }
                }
        }
        .enSet-head{
                width: 100%;
                margin-top: 14px;
                background: rgb(255, 255, 255);
                box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 4px 0px;
                padding-top: 32px;
                padding-bottom: 40px;
                box-sizing: border-box;
                display: flex;
                position: relative;
                .avatar-block{
                    min-width: 200px;
                    .avatar{
                        margin-left: 32px;
                        height: 116px;
                        width: 116px;
                        position: relative;
                        text-align: center;
                        border-radius: 50%;
                        overflow: hidden;
                        .next-avatar{
                         width: 120px;
                        height: 120px;
                        line-height: 120px;
                        font-size: 18px;
                        background: transparent;
                         position: relative;
                        display: inline-block;
                        overflow: hidden;
                        color: #fff;
                        white-space: nowrap;
                        text-align: center;
                        vertical-align: middle;
                        img{
                                display: block;
                                width: 100%;
                                height: 100%;
                                -o-object-fit: cover;
                                object-fit: cover;
                          }
                        }
                        .sc-chPdSV{
                        width: 100%;
                        height: 31px;
                        opacity: 0.75;
                        background: rgb(24, 24, 24);
                        position: absolute;
                        bottom: 0px;
                        font-size: 12px;
                        color: rgb(255, 255, 255);
                        text-align: center;
                        line-height: 31px;
                        cursor: pointer;
                        }
                    }
                }
        }
        .next-form-preview{
                min-width: 600px;
                max-width: 680px;
                width: 100%;
                justify-content: space-between;
                flex-wrap: wrap;
                .next-row {
                    width: 50%;
                    margin-bottom: 20px;
                    .label{
                     height: 18px;
                    font-size: 12px;
                    color: rgb(153, 153, 153);
                    text-align: left;
                    line-height: 18px;
                    white-space: nowrap;
                    width: 100px;
                    max-width: 100px;
                    }
                    .inputPreview{
                        font-size: 12px;
                        padding-left: 30px;
                        span{
                           color: rgb(24, 144, 255);
                           cursor: pointer;
                        }
                    }
                }
        }
        .Setbtn{
            height: 44px;
            background: #2C71C8;
            border-radius: 2px;
            text-align: center;
            line-height: 44px;
            color: #fff;
            padding: 0 30px;
            margin: 100px auto;
            width: 200px;
            cursor: pointer;
        }
    }
    ::v-deep{
        .form-edit{
    width: 80%;
    margin: 0 auto;
    .el-input{
        margin-bottom: 30px;
    }
    .el-input-group__append{
        background: #2C71C8;
        border:none
    }
    .sendCode{
        color: #fff;
        width: 100%;
        height: inherit;
        cursor: pointer;
    }
}
        .formUp{
            text-align: center;
        }
            .subBtn{
        justify-content: center;
        margin-top: 30px;
        div{
       margin-right: 30px;
       width: 100px;
        height: 40px;
        border-radius: 2px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        }
        .cancl{
            background: #F4F4F4;
            border: 1px solid #E1E1E1;
            color: #1A1A1A;
        }
        .subTd{
            color: #fff;
            background: #2C71C8;
       width: 100px;
        height: 40px;
        border-radius: 2px;
        text-align: center;
        cursor: pointer;
        }
    }
         .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    }
    @media (max-width: 640px){
        #enSet{
            margin-top: -56px;
            .app-init-container{
                width: 95%;
                .wrapper-app{
                    width: 100%;
                    .header-title-wrap{
                        top: 0;
                    }
                    .cen-content{
                        .form-horizontal{
                            padding-left: 0;
                            .control-label{
                                text-align: left;
                                width: 80px;
                            }
                            .controls{
                                margin-left: 0;
                            }
                        }
                    }
                }
            }
        }
    }
    ::v-deep{
         @media (max-width: 640px){
           .el-dialog{
             width: 90% !important;
           }
                   .el-message-box {
            width: 90% !important;
           }
            
         }
    }
</style>